<template>
  <div id="box" class="error">
    <div class="inner">
      <h1 v-html="$t('404Error.title')" />
      <p v-html="$t('404Error.description')" class="description center" />
      <div class="expandWrapper">
        <img
          v-svg-inline
          class="img"
          src="../assets/imgs/notFound.svg"
          alt="Not found"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="sass" scoped>
.expandWrapper
  +flex()
  .img
    +size(80%)
</style>